import React, { useEffect, useState } from 'react';
import styles from './css/HeaderSidebars.module.css';
import { CheckmarkCircle20Filled, CheckmarkCircle20Regular, ChevronDown20Regular } from '@fluentui/react-icons';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteNote, DeleteNotePage, GetNotes, PatchNote, PatchNotesPage, PostNote, PostNotesPage, RewriteNote, clearRewrittenNote } from '../../redux/dashboardSlice';
import JournalEditor from '../Journal/JournalEditor';
// import MenuItem from 'react-bootstrap/esm/DropdownItem';
import { format } from 'date-fns';
import { DrawerBody, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, OverlayDrawer } from '@fluentui/react-components';
import { toast } from 'react-toastify';

export const NotepadSidebar = ({ show, setShow }) => {
    const dispatch = useDispatch();
    const { selectedProject } = useSelector(state => state.projectData);
    const { user } = useSelector(state => state.user);
    const { notes } = useSelector(state => state.dashboard);
    const [isSectionDropdownOpen, setIsSectionDropdownOpen] = useState(false);
    const [selectedSection, setSelectedSection] = useState(null);
    const [title, setTitle] = useState('');
    const [editorApiRef, setEditorApiRef] = useState(null);
    const [editorContent, setEditorContent] = useState('');

    // Fetch notes when sidebar is shown
    useEffect(() => {
        if (show) {
            dispatch(GetNotes());
        }
    }, [show, dispatch]);
    const handleSaveEntry = async () => {
        if (!selectedSection) {
            console.error('No section selected');
            return;
        }

        try {
            // Get content from editor (Quill returns HTML directly)
            let html = '';
            try {
                html = (await editorApiRef?.save?.()) || '';
            } catch (_) {
                // Editor might not be initialized; treat as empty content
                html = '';
            }

            // Don't save if content is empty
            const textContent = html.replace(/<[^>]*>/g, '').trim();
            if (!textContent) {
                toast.error('Please enter some content before saving');
                return;
            }

            // Create note (only notes field now)
            await dispatch(
                PostNote({
                    notepad: selectedSection.id,
                    notes: html || '',
                }),
            );

            // Clear editor
            if (editorApiRef?.clear) {
                editorApiRef.clear();
            }
            setEditorContent(''); // Clear the content state

            toast.success('Saved note');
        } catch (error) {
            console.error('Failed to save note:', error);
            toast.error('Failed to save note');
        }
    };
    return (
        <div>
            <OverlayDrawer style={{ minWidth: 400 }} type="overlay" position="end" open={show} onOpenChange={(_, { open }) => setShow(open)}>
                <DrawerBody style={{ padding: 0 }}>
                    <div>
                        <p className={styles.sidebarTitle}>Journal</p>
                        <div style={{ padding: 24 }}>
                            <label className={styles.label}>
                                Add Entry to Section <span style={{ color: 'var(--danger)' }}>*</span>
                            </label>
                            <Menu open={isSectionDropdownOpen} onOpenChange={(e, data) => setIsSectionDropdownOpen(data.open)}>
                                <MenuTrigger disableButtonEnhancement>
                                    <div className={styles.sectionInput}>
                                        <span className="d-flex align-items-center gap-2">
                                            {selectedSection?.name || 'Select Section'}

                                            {selectedSection && (
                                                <>
                                                    {((selectedSection?.shared_with?.length > 0 && selectedSection?.created_by === user?.id) ||
                                                        (selectedSection?.is_project_default && selectedSection?.created_by === user?.id)) && (
                                                        <div className={styles.sectionTag} style={{ backgroundColor: '#192BC2' }}>
                                                            Shared
                                                        </div>
                                                    )}
                                                    {selectedSection?.is_shared && (
                                                        <div className={styles.sectionTag} style={{ backgroundColor: 'var(--Brand-Secondary)' }}>
                                                            {selectedSection?.owner_name}
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </span>
                                        <ChevronDown20Regular />
                                    </div>
                                </MenuTrigger>
                                <MenuPopover style={{ width: '400px' }}>
                                    <MenuList>
                                        {notes?.map(section => (
                                            <MenuItem
                                                key={section.id}
                                                onClick={() => {
                                                    setSelectedSection(section);
                                                    setIsSectionDropdownOpen(false);
                                                }}>
                                                <div className="d-flex align-items-center gap-2">
                                                    {' '}
                                                    {section.name}{' '}
                                                    {((section?.shared_with?.length > 0 && section?.created_by === user?.id) ||
                                                        (section?.is_project_default && section?.created_by === user?.id)) && (
                                                        <div className={styles.sectionTag} style={{ backgroundColor: '#192BC2' }}>
                                                            Shared
                                                        </div>
                                                    )}
                                                    {section?.is_shared && (
                                                        <div className={styles.sectionTag} style={{ backgroundColor: 'var(--Brand-Secondary)' }}>
                                                            {section?.owner_name}
                                                        </div>
                                                    )}
                                                </div>
                                            </MenuItem>
                                        ))}
                                        <MenuItem
                                            onClick={async () => {
                                                try {
                                                    const result = await dispatch(
                                                        PostNotesPage({
                                                            name: 'New Section',
                                                            project: localStorage['project_id'],
                                                        }),
                                                    ).unwrap();

                                                    if (result?.data?.id) {
                                                        setSelectedSection(result.data);
                                                        setIsSectionDropdownOpen(false);
                                                    }
                                                } catch (error) {
                                                    console.error('Failed to create new section:', error);
                                                }
                                            }}>
                                            + Add new section
                                        </MenuItem>
                                    </MenuList>
                                </MenuPopover>
                            </Menu>
                            {/* Title field removed */}
                            <div className={styles.editorWrapper + ' mt-3'}>
                                <JournalEditor
                                    holder="journal-editor-sidebar"
                                    placeholder="Start writing..."
                                    initialData={editorContent}
                                    onReadyApi={api => setEditorApiRef(api)}
                                    onChange={html => setEditorContent(html)}
                                    onBlur={() => {}}
                                    isNewNote={true}
                                    sidebar={true}
                                />
                            </div>
                            <div className="mt-4 mb-4 text-end">
                                <button className={styles.smallSaveBtn} onClick={handleSaveEntry}>
                                    Save Entry
                                </button>
                                {/* <CheckmarkCircle20Filled role="button" onClick={handleSaveEntry} color="var(--Brand-Secondary)" /> */}
                            </div>
                        </div>
                    </div>
                </DrawerBody>
            </OverlayDrawer>
        </div>
    );
};
